import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import PronosticoLocalMapasService, { PronosticoLocalMapasInterface } from '@/domain/services/PronosticoLocalMapasService'
import { PronosticoLocalMapasState, StoreError } from '@/store/modules/pronostico-local-mapas/types'

const PronosticoLocalMapas: PronosticoLocalMapasInterface = new PronosticoLocalMapasService()

export const actions: ActionTree<PronosticoLocalMapasState, RootState> = {
  async getPronosticoLocalMapas ({ commit }): Promise<any> {
    try {
      const actionResponse = await PronosticoLocalMapas.getPronosticoLocalMapas()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
